import { useState } from "react";
import Client, {
  CLIENT_TYPE_ENTITY,
  CLIENT_TYPE_ENTITY_LABEL,
  CLIENT_TYPE_PERSON,
  CLIENT_TYPE_PERSON_LABEL,
} from "../../models/client";
import { CCard, CCardBody, CCardHeader, CCollapse } from "@coreui/react";

import ClientCrudActions from "./ClientCrudActions";

interface ClientCardProps {
  client: Client;
  onUpdateClick: (inv: Client) => void;
  onDeleteClick: (inv: Client) => void;
}

export function ClientCard({
  client,
  onUpdateClick,
  onDeleteClick,
}: ClientCardProps) {
  const [open, setOpen] = useState(true);
  const ruc = client.ruc ? client.ruc : "-";
  let typeStr = "-";
  if (client.type === CLIENT_TYPE_PERSON) {
    typeStr = CLIENT_TYPE_PERSON_LABEL;
  } else if (client.type === CLIENT_TYPE_ENTITY) {
    typeStr = CLIENT_TYPE_ENTITY_LABEL;
  }
  return (
    <CCard className="mb-2">
      <CCardHeader
        className="d-flex justify-content-between align-items-center cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <span>
          <strong>{client.socialName}</strong>
        </span>
        <span className="d-flex align-items-center gap-2">
          <strong>{client.ruc}</strong>
          <span
            className="rounded-circle bg-white d-flex justify-content-center align-items-center ml-1 border border-dark"
            style={{ width: "22px", height: "22px" }}
          >
            <i
              className={`fa fa-chevron-${open ? "up" : "down"}`}
              style={{ color: "black", fontSize: "12px" }}
            />
          </span>
        </span>
      </CCardHeader>
      <CCollapse show={open}>
        <CCardBody>
          <p>
            <strong>Razón Social:</strong> {client.socialName}
          </p>
          {client.fantasyName && (
            <p>
              <strong>Nombre de Fantasia:</strong> {client.fantasyName}
            </p>
          )}
          <p>
            <strong>RUC o CI:</strong> {ruc}
          </p>
          <p>
            <strong>Tipo:</strong> {typeStr}
          </p>

          {client.phoneNumber && (
            <p>
              <strong>Teléfono:</strong> {client.phoneNumber}
            </p>
          )}

          {client.email && (
            <p>
              <strong>Email:</strong> {client.email}
            </p>
          )}

          <div>
            <strong>Acciones disponibles:</strong>{" "}
            <ClientCrudActions
              client={client}
              onUpdateClick={onUpdateClick}
              onDeleteClick={onDeleteClick}
            />
          </div>
        </CCardBody>
      </CCollapse>
    </CCard>
  );
}
